// extracted by mini-css-extract-plugin
module.exports = {"word":"_35473596d19850be7c52c970cf918de8"};